import React from 'react';

import { SVGComponentProps } from './svg.types';

const CommentsOneSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSVGProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...otherSVGProps}
      >
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      </svg>
    </span>
  );
};

export default CommentsOneSVG;
